import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, from, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ChatBotMapper } from '../Mappers/chat-bot.mapper';
import { ContextRequest, History, Message, PromptButton, SystemPrompt } from '../Models/chat-bot.model';
import { Config } from '../constants/constants';
import { EndPointsConfig } from '../helper/endpoints/endpoints.config';
import { WebapiService } from '../helper/services/webapi/webapi.service';
import { environment } from 'src/environments/environment';
import { EventSourcePolyfill } from 'event-source-polyfill';



@Injectable({
  providedIn: 'root'
})
export class MeteredgptChatBotService {
  conversation = new Subject<Message[]>();
  botResponse: any = Config.BOT_RESPONSE;
  promptButtons: PromptButton[] = [];
  contextObjList: any[] = [];
  botContextRequest = new ContextRequest();
  currentContext = new Subject<string>();
  private eventSource: EventSource;
  private eventsSubject: Subject<MessageEvent>;

  constructor(private webapiService: WebapiService, private chatBotMapper: ChatBotMapper, private http: HttpClient) {
    this.eventsSubject = new Subject<MessageEvent>();
  }

  connect(prompt: string, systemPrompt: string, history: History[], accessToken: string): Observable<MessageEvent> {
    if (!this.eventSource || this.eventSource.readyState === EventSource.CLOSED) {
      let parameters = {};
      if (history.length > 10) {
        history.shift();
      }
      prompt = encodeURIComponent(prompt);
      systemPrompt = encodeURIComponent(systemPrompt);
      let historyParam = JSON.stringify(history);
      let params = JSON.stringify(parameters);
      let endpoint = environment.apiUrl + EndPointsConfig.SystemPrompt +
        'system_prompt=' + systemPrompt +
        '&prompt=' + prompt +
        '&history=' + historyParam +
        '&parameters=' + params;

      const headers = {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      };

      try {
        this.eventSource = new EventSourcePolyfill(endpoint, headers);

        this.eventSource.onmessage = (event: MessageEvent) => {
          this.eventsSubject.next(event);
        };

        this.eventSource.onerror = (errorEvent: Event) => {
          console.error('Error occurred:', errorEvent);
          this.eventSource.close();
          this.eventsSubject.error('Connection error occurred. Please try again.');
          this.eventsSubject = new Subject<MessageEvent>();
          const botMessage = this.chatBotMapper.MapMessages(false, 'Connection error occurred. Please try again.', 0, true, 'error');
          this.conversation.next([botMessage]);
        };
      } catch (error) {
        console.log('EventError:', error);
        this.eventsSubject.error('EventSource creation failed. Please try again.');
        return of(error);
      }
    }

    return this.eventsSubject.asObservable();
  }

  closeConnection() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventsSubject = new Subject<MessageEvent>();
    }
  }
}
